import { EventEmitter, Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IBatchcredit,
  IBatchCreditInfo,
  IclearFilterGrid,
  ICountTabs,
  IEditPosting,
  ISeachTrip,
  IUpdateRowAmount
} from '../interfaces/posting.interface';

@Injectable()
export class PostingService extends ParentService {
  subscriptions: Subscription[] = [];
  /** Manage form data. */
  private batchInfoIdSubject = new BehaviorSubject<Number>(null);
  batchInfoId = this.batchInfoIdSubject.asObservable();
  /** Reload all form data */
  private reloadBatchDataSubejct = new BehaviorSubject<boolean>(false);
  reloadBatchData$ = this.reloadBatchDataSubejct.asObservable();
  /** Data that fills the lower grid */
  private batchCreditListSubject = new BehaviorSubject<IBatchCreditInfo>(null);
  batchCreditList$ = this.batchCreditListSubject.asObservable();
  /** Manage the data displayed in the lower grid */
  private tabExceptionsSubject = new BehaviorSubject<string>(null);
  tabExceptions$ = this.tabExceptionsSubject.asObservable();
  /** It is used to search for a trio and edit their credit */
  private creditEditSubject = new BehaviorSubject<ISeachTrip>(null);
  creditEditSubject$ = this.creditEditSubject.asObservable();
  /** It is used to manage the button to remove a credit */
  private arrayBatchcreditidSubject = new BehaviorSubject<number[]>(null);
  arrayBatchcreditid$ = this.arrayBatchcreditidSubject.asObservable();
  /** It is used to manage the information of a credit by double clicking on the lower grid */
  private editBatchCreditSubject = new BehaviorSubject<IBatchcredit>(null);
  editBatchCredit$ = this.editBatchCreditSubject.asObservable();
  /** It is used to open and close the modal of adding a credit */
  private openCreditModalSubject = new BehaviorSubject<boolean>(false);
  openCreditModal = this.openCreditModalSubject.asObservable();
  /** Used to reload the main grid */
  private saveSubject = new BehaviorSubject<boolean>(false);
  saveSubject$ = this.saveSubject.asObservable();

  private countTabsSubject = new BehaviorSubject<ICountTabs>(null);
  countTabs$ = this.countTabsSubject.asObservable();

  /** Clear filter grid */
  private clearFilterGrid = new BehaviorSubject<IclearFilterGrid>(null);
  clearFilterGrid$ =  this.clearFilterGrid.asObservable();

  denialCode$ = new BehaviorSubject<{ code?: string; type: string; }>(null);
  denialCode = this.denialCode$.asObservable();

  private enableReadOnlyModeSubject = new BehaviorSubject<boolean>(false);
  enableReadOnlyMode$ = this.enableReadOnlyModeSubject.asObservable();

  private updateRowAmountSubject = new BehaviorSubject<IUpdateRowAmount>(null);
  updateRowAmount$ = this.updateRowAmountSubject.asObservable();

  modeEditCreditSubject = new BehaviorSubject<IEditPosting>(null);
  modeEditCredit$ = this.modeEditCreditSubject.asObservable();

  closeModal: EventEmitter<boolean>  = new EventEmitter();

  private clearAllSubjects = new BehaviorSubject<boolean>(false);
  clearAll$ = this.clearAllSubjects.asObservable();

  private dataModalReservationSubejct = new BehaviorSubject<any>(null);
  dataModalReservation$ = this.dataModalReservationSubejct.asObservable();

  modalChargesDetails: EventEmitter<{isOpen: boolean}>  = new EventEmitter();

  private dataGrid = new BehaviorSubject<IBatchcredit>(null);
  dataGrid$ = this.dataGrid.asObservable();

  private closedModalDenialCategory = new BehaviorSubject<boolean>(false);
  closedModalDenialCategory$ = this.closedModalDenialCategory.asObservable();

  constructor(private http: Http) {
    super();
    this.subscriptions.push(
      this.clearAll$.subscribe((resp) => {
        if (resp) {
          this.setBatchInfoId(null);
          this.sendDataReservation(null);
          this.setEnableReadOnlyMode(false);
          this.setBatchCreditListSubject(null);
          this.setTabExceptions(null);
          this.reloadMainGrid(false);
          this.onOpenCreditModal(false);
          this.onClearFilterGrid(null);
          this.setArrayBatchcreditIds([]);
          this.onEditBatchCredit(null);
          this.onCountTabs(null);
          this.onCreditEdit(null);
          this.reloadBatchData(false);
          this.onUpdateRowAmount(null);
          this.denialCode$.next(null);
        }
      })
    );
  }

  sendDataGrid(data) {
    this.dataGrid.next(data);
  }

  sendDataReservation(data: any) {
    this.dataModalReservationSubejct.next(data);
  }

  setBatchInfoId(batchinfoid: number) {
    this.batchInfoIdSubject.next(batchinfoid);
  }

  setEnableReadOnlyMode(enable: boolean) {
    this.enableReadOnlyModeSubject.next(enable);
  }

  setBatchCreditListSubject(data: IBatchCreditInfo) {
    this.batchCreditListSubject.next(data);
  }

  setTabExceptions(tab: string) {
    this.tabExceptionsSubject.next(tab);
  }

  setArrayBatchcreditIds(ids: number[]) {
    this.arrayBatchcreditidSubject.next(ids);
  }

  reloadMainGrid(save: boolean) {
    this.saveSubject.next(save);
  }

  onOpenCreditModal(open: boolean) {
    this.openCreditModalSubject.next(open);
  }

  onClearFilterGrid(data: IclearFilterGrid) {
    this.clearFilterGrid.next(data);
  }

  onCountTabs(data: ICountTabs) {
    this.countTabsSubject.next(data);
  }

  onEditBatchCredit(data: IBatchcredit) {
    this.editBatchCreditSubject.next(data);
  }

  onCreditEdit(data: ISeachTrip) {
    this.creditEditSubject.next(data);
  }

  onUpdateRowAmount(data: IUpdateRowAmount) {
    this.updateRowAmountSubject.next(data);
  }

  reloadBatchData(reload: boolean) {
    this.reloadBatchDataSubejct.next(reload);
  }

  clearAllBhSubjects() {
    this.clearAllSubjects.next(true);
  }

  updateBatchInfo(data: any): Observable<any> {
    const url = constant.URL_UPDATE_BATCH_INFO;
    return this.http
      .put(url, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  addPostingBatchCredit(data: any) {
    const url = constant.URL_POST_BATCH_CREDIT;
    return this.http
      .post(url, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  getListPostingBatchCredit(body: { startdate: any, enddate: any, isposting: boolean  }) {
    const url = constant.URL_GET_POSTING_CREDIT_LIST;
    return this.http
      .post(url, body, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getBachInfoById(batchinfoid: number) {
    const url = `${constant.URL_POSTING}/${batchinfoid}`;
    return this.http
      .get(url, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getAllCreditList(): Observable<any> {
    const url = `${constant.URL_CREDIT}/All`;
    return this.http
      .get(url, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getCreditTypeList(type: number, onlyCodeCo45?: boolean) {
    const onlyCode45 = onlyCodeCo45 ? '?onlyCo45=true' : '';
    const url = `${constant.URL_GET_CREDIT_TYPE_LIST}/${type}${onlyCode45}`;
    return this.http
      .get(url, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getCreditInfoById(data: { tripid: number, batchinfoid: string } ): Observable<any> {
    const url = constant.URL_GET_BATCH_CREDIT;
    return this.http
      .post(url, { tripid: data.tripid, batchinfoid: data.batchinfoid }, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  searchTrip(data: any) {
    const url = `${constant.URL_SEARCH_POSTING_RESERVATION}`;
    return this.http
      .post(url, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  postSaveBatchCredit(data: any) {
    const url = `${constant.URL_POST_POSTING_BATCH_CREDIT}`;
    return this.http
      .post(url, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  putBatchCredit(data: any) {
    const url = constant.URL_PUT_BATCH_CREDIT;
    return this.http.put(url, data, this.headerPost())
      .map((res: any) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  postDeleteBatchHistory(data: number[]) {
    const url = `${constant.URL_GET_DELETE_BATCH_CREDIT}`;
    return this.http
      .post(url, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  postingBatch(batchinfoid) {
    const url = `${constant.URL_POSTING_BATCH_CREDIT}`;
    return this.http
      .post(url, batchinfoid, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  autoCompleteDenialCode(params) {
    return this.http.post(`${constant.URL_DENIAL_CODE}`, params, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  registerDenialCode(data) {
    return this.http.post(`${constant.URL_ADD_DENIAL_CODE}`, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((response: any) => Observable.throw(response.json()));
  }

   registerDenialCategory(data: { description: any }) {
    return this.http
      .post(`${constant.URL_ADD_DENIAL_CATEGORY}`, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((response: any) => Observable.throw(response.json()));
  }

  autoFill(body: any): Observable<any> {
    const url = `${constant.URL_AUTO_FILL}`;
    return this.http
      .post(url, body, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteAllBatch(batchidlist: number[]): Observable<any> {
    const url = constant.URL_DELETE_ALL_BATCH;
    return this.http
      .post(url, { batchidlist }, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  rollbackBatch(batchidlist: { batchinfoid: number, reason: string } ): Observable<any> {
    const url = constant.URL_ROLLBACK_BATCH;
    return this.http
      .post(url, batchidlist, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  setClosedModalDenialCategory(closed: boolean) {
    this.closedModalDenialCategory.next(closed);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/posting.service.ts